import { ElementRef } from '@angular/core';
import { MessageService } from '@core/errors/messages-service';
import { CopyService } from '@fuse/services/copier.service';
import { chain } from 'lodash';
var RecoveryCodesComponent = /** @class */ (function () {
    function RecoveryCodesComponent(messageService, fuseCopierService) {
        this.messageService = messageService;
        this.fuseCopierService = fuseCopierService;
    }
    RecoveryCodesComponent.prototype.copyRecoveryCodes = function () {
        var value = chain(this.recoveryCodes)
            .filter({ status: 'CURRENT_ACTIVE' })
            .map('plainTextCode')
            .join('; ')
            .value();
        this.fuseCopierService.copyText(value);
        this.messageService.success('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.COPIED', {});
    };
    return RecoveryCodesComponent;
}());
export { RecoveryCodesComponent };
